import { useEffect, useRef } from "react";
import MenuItemLabel from "@/components/MenuItemLabel.jsx";
import "../pages/customer-profile/profile.css";

export default function ProfileLayout({
    title,
    menuItems,
    activeSection,
    onSelectSection,
    message,
    error,
    children
}) {
    const feedbackRef = useRef(null);

    useEffect(() => {
        if ((message || error) && feedbackRef.current) {
            feedbackRef.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }
    }, [message, error]);

    return (
        <main className="container profile-page">
            <h1>{title}</h1>

            <div className="profile-layout">
                <aside className="profile-sidebar card" aria-label="Menu de l'espace personnel" data-tour="profile-sidebar">
                    <h2>Menu</h2>
                    <nav className="profile-menu">
                        {menuItems.map((item) => (
                            <button
                                key={item.id}
                                type="button"
                                className={`profile-menu-btn${activeSection === item.id ? " active" : ""}`}
                                data-tour={`profile-menu-${item.id}`}
                                onClick={() => onSelectSection(item.id)}
                            >
                                <MenuItemLabel icon={item.icon} active={activeSection === item.id}>
                                    {item.label}
                                </MenuItemLabel>
                            </button>
                        ))}
                    </nav>
                </aside>

                <div className="profile-content">
                    {(message || error) && (
                        <div
                            ref={feedbackRef}
                            className="profile-content-feedback profile-content-feedback--toast"
                            role={error ? "alert" : "status"}
                        >
                            {message && <p className="profile-section-feedback profile-section-feedback--success">{message}</p>}
                            {error && <p className="profile-section-feedback profile-section-feedback--error">{error}</p>}
                        </div>
                    )}
                    {children}
                </div>
            </div>
        </main>
    );
}
